import { getMessage } from 'common/helpers/miscHelper';

const Message = (props) => {
  const { settings } = props;
  return (
    <div
      className="c7-message c7-message--club-note"
      dangerouslySetInnerHTML={{
        __html: getMessage('Club Signup Message', settings)
      }}
    />
  );
};

export default Message;
